import { render, staticRenderFns } from "./AdminUserEdit.vue?vue&type=template&id=0b870ada&scoped=true"
import script from "./AdminUserEdit.vue?vue&type=script&lang=js"
export * from "./AdminUserEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminUserEdit.vue?vue&type=style&index=0&id=0b870ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b870ada",
  null
  
)

export default component.exports